import {
	numberFormatter,
	percentageBarFormatter,
	healthColorAlertFormatter,
	integerFormatter,
	redNegativeFormatter,
	capacityScoreFormatter,
	cleanNumberFormatter,
	moneyFormatter
} from "../../gridFormatters";
import { wtPctAvg } from "../../math";

export const hostDefs = [
	{
		"field": "esx_host_name",
		"headerName": "ESX Host Name",
	},
	{
		"field": "cluster_name",
		"headerName": "Cluster Name",
		"hide": true
	},
	{
		"field": "model",
		"headerName": "Model",
	},
	{
		"field": "total_vms",
		"type": "numericColumn",
		"cellRenderer": integerFormatter,
		"headerName": "Total VM/LPARs",
		"filter": "agNumberColumnFilter",
		"aggFunc": "sum",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "total_cpus",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"headerName": "Total CPU's",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "avg_cpu_utilization",
		"type": "numericColumn",
		"aggFunc": "avg",
		"cellRenderer": percentageBarFormatter,
		"headerName": "Avg % CPU Util",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "total_mhz",
		"type": "numericColumn",
		"headerName": "Total MHz",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "max_cpu_utilization",
		"cellRenderer": percentageBarFormatter,
		"type": "numericColumn",
		"headerName": "Highest % CPU Util",
		"hide": true,
		"aggFunc": "max"
	},
	{
		"field": "avg_ghz_per_cpu",
		"type": "numericColumn",
		"headerName": "Avg GHz/CPU",
		"aggFunc": "avg",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"cellRenderer": numberFormatter,
	},
	{
		"field": "total_memory",
		"type": "numericColumn",
		"headerName": "Total Memory (GiB)",
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "avg_memory_util",
		"cellRenderer": percentageBarFormatter,
		"type": "numericColumn",
		"headerName": "Avg % Memory Util",
		"aggFunc": "avg",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "max_memory_util",
		"cellRenderer": percentageBarFormatter,
		"type": "numericColumn",
		"headerName": "Highest % Memory Util",
		"aggFunc": "max",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"hide": true
	},
	{
		"field": "total_disk_allocated",
		"type": "numericColumn",
		"headerName": "Total Disk Allocated",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "total_disk_used",
		"type": "numericColumn",
		"headerName": "Total Disk Used",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "disk_util_pct",
		"cellRenderer": percentageBarFormatter,
		"type": "numericColumn",
		"headerName": "% Disk Used",
		"aggFunc": p => wtPctAvg(p, "total_disk_used", "total_disk_allocated"),
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "vm_build_capacity",
		"type": "numericColumn",
		"headerName": "VM Build Capacity",
		"cellRenderer": redNegativeFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "vm_cpu_build_capacity",
		"type": "numericColumn",
		"headerName": "VM CPU Build Capacity",
		"cellRenderer": redNegativeFormatter,
		"aggFunc": "sum",
		"hide": true,
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "vm_memory_build_capacity",
		"type": "numericColumn",
		"headerName": "VM Memory Build Capacity",
		"cellRenderer": redNegativeFormatter,
		"aggFunc": "sum",
		"hide": true,
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "vm_disk_build_capacity",
		"type": "numericColumn",
		"headerName": "VM Disk Build Capacity",
		"cellRenderer": redNegativeFormatter,
		"aggFunc": "sum",
		"hide": true,
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "host_limiting_factor",
		"headerName": "Host Limiting Factor",
		"hide": true
	},
	{
		"field": "device_type_code",
		"headerName": "Device Type Code",
		"hide": true,
	}
];

export const vmDefs = [
	{
		"field": "vm_name",
		"headerName": "VM Name",
		"filter": "agTextColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		}
	},
	{
		"field": "num_cpus",
		"cellRenderer": numberFormatter,
		"type": "numericColumn",
		"headerName": "Num CPUs",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"aggFunc": "sum"
	},
	{
		"field": "ghz_per_cpu",
		"type": "numericColumn",
		"headerName": "Ghz / CPU",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"aggFunc": "sum"
	},
	{
		"field": "total_mhz",
		"type": "numericColumn",
		"headerName": "Total Mhz",
		"filter": "agNumberColumnFilter",
		"cellRenderer": integerFormatter,
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"aggFunc": "sum"
	},
	{
		"field": "vm_util",
		"type": "numericColumn",
		"headerName": "% CPU Util",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"cellRenderer": percentageBarFormatter,
		"aggFunc": "avg"
	},
	{
		"field": "ghz_used",
		"type": "numericColumn",
		"headerName": "GHZ Used",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"cellRenderer": numberFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "vsi_capacity_score",
		"type": "numericColumn",
		"headerName": "Capacity Score",
		"filter": "agNumberColumnFilter",
		"cellRenderer": capacityScoreFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "memory_allocated",
		"type": "numericColumn",
		"headerName": "Memory Allocated (GiB)",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"aggFunc": "sum"
	},
	{
		"field": "memory_util",
		"type": "numericColumn",
		"headerName": "% Memory Util",
		"filter": "agNumberColumnFilter",
		"cellRenderer": percentageBarFormatter,
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"aggFunc": "avg"
	},
	{
		"field": "disk_allocated",
		"type": "numericColumn",
		"headerName": "Disk Allocated",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"aggFunc": "sum"
	},
	{
		"field": "disk_used",
		"type": "numericColumn",
		"headerName": "Disk Used",
		"filter": "agNumberColumnFilter",
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"aggFunc": "sum"
	},
	{
		"field": "disk_util_pct",
		"type": "numericColumn",
		"headerName": "% Disk Used",
		"filter": "agNumberColumnFilter",
		"cellRenderer": percentageBarFormatter,
		"filterParams": {
			"cellHeight": 20,
			"debounceMs": 1000
		},
		"aggFunc": "avg"
	},
	{
		"field": "os",
		"headerName": "OS",
		"hide": true
	},
	{
		"field": "overall_status",
		"cellRenderer": healthColorAlertFormatter,
		"cellStyle": {
			"text-align": "center"
		},
		"headerName": "Overall Status",
		"hide": true
	},
	{
		"field": "power_state",
		"headerName": "Power State",
		"hide": true
	},
	{
		"field": "boot_date",
		"headerName": "Boot Date",
		"hide": true
	},
	{
		"field": "datacenter_name",
		"headerName": "Datacenter Name",
		"hide": true
	},
	{
		"field": "esx_host_name",
		"headerName": "ESX Host Name",
		"hide": true
	},
	{
		"field": "cluster_name",
		"headerName": "Cluster Name",
		"hide": true
	},
	{
		"field": "device_type_code",
		"headerName": "Device Type Code",
		"hide": true
	},
	{
		"field": "tag_1",
		"headerName": "Tag 1",
		"hide": true
	},
	{
		"field": "tag_2",
		"headerName": "Tag 2",
		"hide": true
	},
	{
		"field": "tag_3",
		"headerName": "Tag 3",
		"hide": true
	},
	{
		"field": "tag_4",
		"headerName": "Tag 4",
		"hide": true
	},
	{
		"field": "tag_5",
		"headerName": "Tag 5",
		"hide": true
	},
	{
		"field": "env_tag",
		"headerName": "Env Tag",
		"hide": true
	},
	{
		"field": "app_tag",
		"headerName": "App Tag",
		"hide": true
	}
];

export const clusterSummaryModelDefs = [
	{
		"field": "type",
		"headerName": "Additions / Subtractions",
		"rowGroup": true,
	},
	{
		"field": "projectName",
		"headerName": "Project Name",
	},
	{
		"field": "notes",
		"headerName": "Notes",
	},
	{
		"field": "date",
		"headerName": "Date",
		"type": "numericColumn",
		// "cellRenderer": dateFormatter,
	},
	{
		"field": "model",
		"headerName": "Hardware Model",
	},
	{
		"field": "cpu",
		"type": "numericColumn",
		"cellRenderer": cleanNumberFormatter,
		"aggFunc": 'sum',
		"headerName": "CPU",
	},
	{
		"field": "mem",
		"type": "numericColumn",
		"cellRenderer": cleanNumberFormatter,
		"aggFunc": 'sum',
		"headerName": "Memory (GiB)",
	},
	{
		"field": "disk",
		"type": "numericColumn",
		"cellRenderer": cleanNumberFormatter,
		"aggFunc": 'sum',
		"headerName": "Disk (GiB)",
	},
	{
		"field": "cost",
		"type": "numericColumn",
		"aggFunc": 'sum',
		"cellRenderer": moneyFormatter,
		"headerName": "Cost ($)",
	},
]
